import {
  getCurrentMonthYear,
  processFestivalOptions,
  processThithiOptions,
} from '@/utils/helper'

interface OptionType {
  id: string
  name: string
}

interface CalendarDay {
  date: string
  festivals?: string[]
  local_day_name?: string
  [key: string]: any
}

interface Deity {
  key: string
  value: string
  day: string
}

interface Rashi {
  key: string
  value: string
  day: string
}

interface SearchMetadataResponse {
  thithiOptions: OptionType[]
  festivalOptions: OptionType[]
  calendarDays: CalendarDay[]
  deities: Deity[]
  rashis: Rashi[]
}

export const fetchSearchMetadata = async (
  networkInstance: any,
): Promise<SearchMetadataResponse> => {
  try {
    const dateParam = getCurrentMonthYear()

    // Execute all three API calls in parallel
    const [panchangResponse, deityResponse, rashiResponse] = await Promise.all([
      networkInstance.clientWithHeaders.gandalf?.getPanchangData(dateParam),
      networkInstance.clientWithHeaders.gandalf?.getDeityRashiData('deity'),
      networkInstance.clientWithHeaders.gandalf?.getDeityRashiData('rashi'),
    ])

    // Process panchang data
    const calendarDays = panchangResponse?.data?.data?.calendar_days || []
    const thithiOptions = processThithiOptions(calendarDays)
    const festivalOptions = processFestivalOptions(calendarDays)

    // Process deity and rashi data
    const deities = deityResponse?.data?.data?.deity || []
    const rashis = rashiResponse?.data?.data?.rashi || []

    return {
      thithiOptions,
      festivalOptions,
      calendarDays,
      deities,
      rashis,
    }
  } catch (error) {
    console.error('Error fetching search metadata:', error)
    throw new Error('Failed to fetch search metadata')
  }
}

export const metadataFields = [
  { name: 'cities', label: 'Cities' },
  { name: 'avatars', label: 'Avatars' },
  { name: 'doshas', label: 'Doshas' },
  { name: 'life_problems', label: 'Life Problems' },
  { name: 'benefits', label: 'Benefits' },
  { name: 'god_weekdays', label: 'God Weekdays' },
  { name: 'mulank', label: 'Mulank' },
  { name: 'temples', label: 'Temples' },
  { name: 'festivals', label: 'Festivals' },
  { name: 'thithis', label: 'Thithis' },
  { name: 'rashis', label: 'Rashis' },
  { name: 'deities', label: 'Deities' },
]

export interface SearchFormValues {
    meta_data?: {
        search_metadata?: {
            cities?: string[];
            avatars?: string[];
            doshas?: string[];
            life_problems?: string[];
            benefits?: string[];
            god_weekdays?: string[];
            mulank?: string[];
            temples?: string[];
            festivals?: string[];
            thithis?: string[];
            rashis?: string[];
            deities?: string[];
        };
    };
}
